import { FC, useEffect } from 'react'
import './Onboarding.scss'
import React from 'react'

type OnboardingQuestion = {
  questionId: string;
  title: string;
  options: string[];
  subTitle: string;
  answer?: string | string[] | null;
  video?: string;
}

type VideoProps = {
  data: OnboardingQuestion;
  setIsDisable: (value: boolean) => void;
}

const Video: FC<VideoProps> = ({ data, setIsDisable }) => {
  useEffect(() => {
    setIsDisable(false);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data?.answer]);

  return (
    <div className='d-flex align-items-center w-100 justify-content-center'>
      <div className="videoouter">
        <div className="video_canvas">
          <iframe 
            width="600" 
            height="400" 
            id="video_canvas" 
            src={data.video ?? "https://www.youtube.com/embed/8AzQGTy5CX4"}
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen 
            loading="lazy" 
            title="Onboarding Video"
            style={{ borderRadius: '12px', boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)' }}
          />
        </div>
      </div>
    </div>
    );
  };

export default React.memo(Video)
